import { defineMessages } from 'react-intl-next';

/**
 * Centralized change type messages for consistent text across the application.
 * Used by the change type filter configuration and UpdateChangeType component.
 */
export const changeTypeMessages = defineMessages({
  improvement: {
    id: 'appUpdates.changeType.improvement',
    defaultMessage: 'Improvement',
    description: "App update is type 'Improvement'",
  },
  fix: {
    id: 'appUpdates.changeType.fix',
    defaultMessage: 'Fix',
    description: "App update is type 'Fix'",
  },
  experiment: {
    id: 'appUpdates.changeType.experiment',
    defaultMessage: 'Experiment',
    description: "App update is type 'Experiment'",
  },
  removed: {
    id: 'appUpdates.changeType.removed',
    defaultMessage: 'Removed',
    description: "App update is type 'Removed'",
  },
  announcement: {
    id: 'appUpdates.changeType.announcement',
    defaultMessage: 'Announcement',
    description: "App update is of type 'Announcement'",
  },
});

/**
 * Change type ID type for type safety
 */
export type ChangeTypeId =
  'IMPROVEMENT' | 'FIX' | 'EXPERIMENT' | 'REMOVED' | 'ANNOUNCEMENT';

/**
 * Get the appropriate message descriptor for a given change type ID
 */
export const getChangeTypeMessage = (changeTypeId: ChangeTypeId) => {
  switch (changeTypeId) {
    case 'IMPROVEMENT':
      return changeTypeMessages.improvement;
    case 'FIX':
      return changeTypeMessages.fix;
    case 'EXPERIMENT':
      return changeTypeMessages.experiment;
    case 'REMOVED':
      return changeTypeMessages.removed;
    case 'ANNOUNCEMENT':
      return changeTypeMessages.announcement;
    default:
      return changeTypeMessages.improvement; // fallback
  }
};
